import script from "./GoTopButton.vue?vue&type=script&setup=true&lang=js"
export * from "./GoTopButton.vue?vue&type=script&setup=true&lang=js"

import "./GoTopButton.vue?vue&type=style&index=0&id=489aaa3f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-489aaa3f"]])

export default __exports__